// extracted by mini-css-extract-plugin
export default {"questionsWrap":"QuestionModal_questionsWrap__q+9Ru","questionContent":"QuestionModal_questionContent__gGnqo","answer":"QuestionModal_answer__ljk8o"};